import React  from 'react'
import numeral from 'numeral'

// Numeral automatically multiplies the value by 100, this function is used instead
function formatPercent(number, rawFormat) {
  const format = rawFormat.replace('%', '')
  return `${numeral(number).format(format)}%`
}

function Numeral({ value, format, ...props }) {
  if (isNaN(value)) return null
  let displayValue
  if (format?.includes('%')) {
    displayValue = formatPercent(value, format)
  } else {
    displayValue = format
      ? numeral(value).format(format)
      : numeral(value).value()
  }
  return <span {...props}>{displayValue}</span>
}

export default React.memo(Numeral)
